(function ($) {
    $(document).ready(function(){
        setTimeout(function(){
            $(".product_detail_slide").each(function(index, element){
                var $this = $(this);

                var swiper = new Swiper($this.find(".swiper-container")[0], {
                    speed: 1000,
                    loop: false,              
                    autoplay: false,                
                    /*
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    */
                    spaceBetween: 0,
                    observer: true,          
                    observeParents: true,
                    pagination: {
                        el: $this.find(".swiper-pagination")[0],
                        type: "bullets",
                        clickable: true,
                    },
                    breakpoints: {
                        990: {
                            spaceBetween: 0,
                        },
                    },
                    on: {
                        init: function () {
                            if (this.pagination && this.pagination.update) {
                                this.pagination.update();
                            }
                        },
                        slideChange: function () {
                            if (this.pagination && this.pagination.update) {
                                this.pagination.update();
                            }
                        }
                    },
                });
            });
        }, 1000);
    });
})(jQuery);

